export default __webpack_public_path__ + "static/media/Witcion.6c49e83d.mp4";